import client from 'api/client'

export const getBuyerNotifications = (page) =>
  client.get(`/notification/buyer/list?page=${page}`)

export const getLatestNotifications = () =>
  client.get('/notification/buyer/latest/list')

export const markNotificationRead = (id) =>
  client.post(`/notification/buyer/read/${id}`)

export const markAllNotificationsRead = () =>
  client.post('/notification/buyer/all/read')

export const updateUserRole = (role, socketId) =>
  client.put('/auth/user/update-role', { role, socketId })

export const getAnnouncement = (id) =>
  client.get(`/auth/user/announcement/details/${id}`)

export const resetFinancialDetails = () =>
  client.delete('/auth/financial/financial-details/reset')
